export class Partner{
    public PartnerID!: number;
    public BusinessName!:string;
    public ContactPerson!:string;
    public FirstName!:string;
    public LastName!:string;
    public Mobile1!:string;
    public Mobile2!:string;
    public Address!: string;
    public GcashNo!:string;
    public GcashAccountName!:string;
    public StoreName!: string;

    public ReferralFee50kg!:number;
    public ReferralFee22kg!:number;
    public ReferralFee11kg!:number;
    public ReferralFee5kg!:number;
    public ReferralFee2_7kg!:number;
    


    constructor(init?:Partial<Partner>){
        Object.assign(this, init);
    }
}

